import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.views-title',
		defaultMessage: 'Views',
		description: 'Title text of the views feature group',
	},
	channelsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.channels-title',
		defaultMessage: 'Channels',
		description: 'Title text of the channels feature group',
	},
	essentialsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.essentials-title',
		defaultMessage: 'Essentials',
		description: 'Title text of the essentials feature group',
	},
	workTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.work-title',
		defaultMessage: 'Work categories',
		description: 'Title text of the work feature group',
	},
	customerServiceTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.customer-service-title',
		defaultMessage: 'Customer service',
		description: 'Title text of the customer service feature group',
	},
	operationsTitle: {
		id: 'servicedesk-itsm-features.app.sections.service-project-section.operations-title',
		defaultMessage: 'Operations',
		description: 'Title text of the operations feature group',
	},
});
